import React from 'react';

import {
	StyledLoader,
	StyledLoaderReports,
	StyledLoaderMain,
	StyledLoaderPdf,
	StyledLoaderLogos,
	StyledDefaultLoader,
	StyledOverlayLoader,
}
from './style/StyledLoader';

export const LoaderFull = () => (
	<StyledLoader>
		<i className="fa fa-spinner fa-pulse" />
	</StyledLoader>
);

export const LoaderPdf = () => (
	<StyledLoaderPdf>
		<i className="fa fa-spinner fa-pulse" />
	</StyledLoaderPdf>
);


export const LoaderReports = () => (
	<StyledLoaderReports>
		<h4>Estamos carregando seus relatórios...</h4>
		<p>Por favor, aguarde!</p>
	</StyledLoaderReports>
);

export const LoaderMain = () => (
	<StyledLoaderMain>
		<svg className="cockpit-load__icon" id="svg_1562266102224" viewBox="0 0 77 77">
			<path
				className="st0"
				d="M38.3,0.2C17.1,0.2,0,17.3,0,38.4c0,21.1,17.1,38.3,38.3,38.3c21.1,0,38.3-17.1,38.3-38.3 C76.5,17.3,59.4,0.2,38.3,0.2z M59.6,51.6c0,1.8-1.5,3.2-3.3,3.2c-1.7-0.1-3-1.6-3-3.3v-8.2c0-0.9-0.8-1.7-1.7-1.7h-8.5 c-0.9,0-1.7,0.8-1.7,1.7v10.2c0,1.8-1.5,3.2-3.3,3.2c-1.7-0.1-3-1.6-3-3.3v-10c0-0.9-0.8-1.7-1.7-1.7h-8.5c-0.9,0-1.7,0.8-1.7,1.7 v8.4c0,1.8-1.5,3.2-3.3,3.2c-1.7-0.1-3-1.6-3-3.3V25.2c0-1.8,1.5-3.2,3.3-3.2c1.7,0.1,3,1.6,3,3.3v8.2c0,0.9,0.8,1.7,1.7,1.7h8.5 c0.9,0,1.7-0.8,1.7-1.7V23.4c0-1.8,1.5-3.2,3.3-3.2c1.7,0.1,3,1.6,3,3.3v10c0,0.9,0.8,1.7,1.7,1.7h8.5c0.9,0,1.7-0.8,1.7-1.7v-8.2 c0-1.7,1.3-3.2,3-3.3c1.8-0.1,3.3,1.4,3.3,3.2V51.6z"
			/>
		</svg>

		<p>Carregando...</p>
	</StyledLoaderMain>
);

export const LoaderLogos = () => (
	<StyledLoaderLogos>
		<i className="fa fa-spinner fa-pulse" />
	</StyledLoaderLogos>
);

export const Loader = ({ color }) => (
	<StyledDefaultLoader fill={color}>
		<i className="fa fa-spinner fa-pulse" />
	</StyledDefaultLoader>
);


export const Overlayder = ({ text }) => (
	<StyledOverlayLoader>
		<i className="fa fa-circle-o-notch fa-spin" />
		<span>{ text }</span>
	</StyledOverlayLoader>
);
